import useSWR from "swr"
import {API_ECP_PROJECTS} from "../constants/apiUrls"

export default function useEcpTranscription(projectId) {
    const {data, mutate, error} = useSWR(`${API_ECP_PROJECTS}/${projectId}/transcription`)
    return {
        ecpTranscription: data,
        mutateEcpTranscription: mutate,
        isLoadingEcpTranscription: !error && !data,
        isErrorEcpTranscription: error
    }
}